import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useWindowDimensions from "../../components/useWindowDimensions";
import IconBar from "../Partials/IconBar";
import TabPages from "../Partials/TabPages";
import Report from "../Documents/Report";
import TestHistory from "../Documents/TestHistory";
import Leaderboard from "../Documents/Leaderboard";
import EditAccount from "../Admin/EditAccount";
export default function ProfileDashboard(props) {
  const history = useHistory();
  const { height, width } = useWindowDimensions();
  const activateReport = () => setTabPage("report");
  const activateHistory = () => setTabPage("history");
  const activateProfile = () => setTabPage("profile");
  const activateLeaderboard = () => setTabPage("leaderboard");
  // Hooks must be called unconditionally
  const [tabPage, setTabPage] = useState("report");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // If the necessary props are not available, redirect to login
  if (!props?.location?.state?.user) {
    history.push("/login");
    return null; // Ensure the component does not render if redirected
  }
  const user = props.location.state.user;
  const tabHeadings: (string | React.ReactNode)[] = ["REPORT", "HISTORY", "PROFILE"];
  const tabFunctions = [getReport, getHistory, getProfile, getLeaderboard];
  function getReport() {
    history.push("/report", { user: user });
  }
  function getHistory() {
    history.push("/history", { user: user });
  }
  function getProfile() {
    history.push("/profile", { user: user });
  }
  function getLeaderboard() {
    history.push("/leaderboard", { user: user });
  }
  const tabActive = 2;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: windowWidth >= 800 ? "50%" : "90%",
      }}
    >
      <div>
        <div className="HeaderBox">
          <IconBar location={"profile"} user={user} />
        </div>
        <div>
          <TabPages
            tabHeadings={tabHeadings}
            tabFunctions={tabFunctions}
            tabActive={tabActive}
          />
        </div>
        <div style={{ height: "90%" }}>
          <EditAccount user={user} />
        </div>
      </div>
    </div>
  );
}
